<template>
  <div class="animated revealUp">
    <div class="white-wrapper" style="zoom: 0.85">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ $t("fnbCourtseyRefundReport") }}
          <!-- <span>as per show date</span> -->
        </div>
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center">
            <input
              value="1"
              id="en_lang"
              name="en_lang"
              type="radio"
              v-model="lang_id"
            />
            <label class="ml-1" for="en_lang">English</label>
          </div>
          <div class="d-flex align-items-center ml-2">
            <input
              value="2"
              id="ar_lang"
              name="ar_lang"
              type="radio"
              v-model="lang_id"
            />

            <label class="ml-1" for="ar_lang">العربية</label>
          </div>
        </div>
      </div>
      <small
        ><em>{{ $t("* As Per Trx Date") }}</em></small
      >
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema && dropDown.selectedCinema
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedCourtseyUsers && selectedCourtseyUsers.length
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{
                  selectedCourtseyUsers && selectedCourtseyUsers.length
                    ? `${$tc("users", 1)}`
                    : `${$t("all")} ${$tc("users", 1)}`
                }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="CourtseyUsers"
                v-model="selectedCourtseyUsers"
                :searchable="true"
                label="username"
                track-by="cu_id"
                placeholder=""
                :showLabels="false"
                :multiple="true"
              ></multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedHardware && selectedHardware.length
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{
                  selectedHardware && selectedHardware.length
                    ? "Concession"
                    : "All Concessions"
                }}</label
              >
              <multiselect
                :options="HardwareLists"
                v-model="selectedHardware"
                :searchable="true"
                label="hs_hardware_name"
                track-by="hs_id"
                placeholder=""
                :showLabels="false"
                :multiple="true"
              ></multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("todate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="courtseyRecords.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>

        <img
          @click="getFnbCourtseyReport('Y', 'N')"
          class="cursor-pointer"
          height="25"
          src="@/assets/img/icons/pdf-icon.svg"
          width="25"
        />

        <img
          @click="getFnbCourtseyReport('N', 'Y')"
          class="cursor-pointer ml-1"
          height="25"
          src="@/assets/img/icons/excel.svg"
          width="25"
        />
      </div>

      <div class="swc-report">
        <table
          class="swc-report-table swc_table_header mb-4"
          :class="
            lang_id == 2
              ? 'swc-report-table reverse-order '
              : 'swc-report-table order '
          "
          border="1"
        >
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ trans("refundedby", lang_id) }}</th>
              <th>{{ trans("personalName", lang_id) }}</th>
              <th>{{ trans("totalPrice", lang_id) }}</th>
              <th>{{ trans("concessionHardware", lang_id) }}</th>
              <th>{{ trans("qty", lang_id) }}</th>
              <th>{{ trans("item", lang_id) }}</th>
              <th>{{ trans("refunddatetime", lang_id) }}</th>
            </tr>
          </thead>
          <tbody v-if="courtseyRecords.length">
            <tr v-for="(item, itemIndex) in courtseyRecords" :key="itemIndex">
              <td class="text-left">{{ item.refunded_by || "-" }}</td>
              <td class="text-left">
                {{
                  lang_id == 2
                    ? item["alt_username"] || item["username"]
                    : item["username"]
                }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(item.fp_total_amount_before_offer).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-left">{{ item.hardware_name || "-" }}</td>
              <td class="text-right">{{ item.fst_quantity || "-" }}</td>
              <td class="text-left">
                {{
                  lang_id == 2
                    ? item.alternate_lang_item_name || item.fst_item_name || "-"
                    : item.fst_item_name || "-"
                }}
              </td>
              <td>{{ item.refund_datetime }}</td>
            </tr>
            <tr>
              <td colspan="2"></td>
              <td class="text-right font-weight-bold" colspan="1">
                {{
                  parseFloat(
                    courtseyRecords.reduce(
                      (acc, { fp_total_amount_before_offer }) =>
                        acc + fp_total_amount_before_offer,
                      0
                    ) || 0
                  ).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td></td>
              <td class="text-right font-weight-bold">
                {{
                  parseFloat(
                    courtseyRecords.reduce(
                      (acc, { fst_quantity }) => acc + fst_quantity,
                      0
                    ) || 0
                  )
                }}
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="6">No Records</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
      
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import NewReportService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    // LangSwitcher,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddres: null,
      },
      fromDate: new Date(),
      toDate: new Date(),
      groupedData: {},
      courtseyRecords: [],
      CourtseyUsers: [],
      HardwareLists: [],
      selectedCourtseyUsers: "",
      selectedHardware: "",
      courtsey_user_id: null,
      selectedLanguage: "en",
      lang_id: "1",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.getCourtseyUsersList();
  },
  watch: {},
  mounted() {},
  computed: {
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
    //
  },
  methods: {
    moment,
    onChangeDate(e, type) {
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    onSelectCourtseyUsers(user, type = "select") {
      if (type == "select") {
        this.selectedCourtseyUsers = user;
        this.courtsey_user_id = user["cu_id"];
      } else {
        this.selectedCourtseyUsers = null;
        this.courtsey_user_id = null;
      }
    },
    onSelectHardware(hardware, type = "select") {
      if (type == "select") {
        this.selectedHardware = hardware;
      } else {
        this.selectedHardware = null;
      }
    },
    getCourtseyUsersList: function () {
      let payload = {
        tableName: "ms_courtsey_users",
        cu_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CourtseyUsers = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getHardwareList: function (cinema_id) {
      let payload = {
        cinema_id: cinema_id || this.dropDown.selectedCinemaId,
      };
      NewReportService.getHardwareList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.HardwareLists = data.Records;
          } else {
            this.HardwareLists = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaAddres = event.cine_address;
      this.$store.dispatch("selectDropdownCinema", event);
      this.getHardwareList(event.cine_id);
    },
    onSubmit() {
      this.getFnbCourtseyReport();
    },
    async getFnbCourtseyReport(isPdf = "N", isExcel = "N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      }
      let loader;
      try {
        loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          fromDate: this.fromDate,
          toDate: this.toDate,
          isPdf,
          isExcel,
          lang_id: this.lang_id,
          language: this.selectedLanguage,
          usernames:
            this.selectedCourtseyUsers && this.selectedCourtseyUsers.length
              ? this.selectedCourtseyUsers.map((x) => x.username)
              : null,
          user_id:
            this.selectedCourtseyUsers && this.selectedCourtseyUsers.length
              ? this.selectedCourtseyUsers.map((x) => x.cu_id)
              : null,
          hardware_name:
            this.selectedHardware && this.selectedHardware.length
              ? this.selectedHardware.map((x) => x.hs_hardware_name)
              : null,
        };
        let response = await NewReportService.getFnbCourtseyRefundReport(
          payload
        );
        const { data } = response;
        if (data.status && data.Records.length) {
          this.courtseyRecords = data.Records;
          this.groupedData = data.groupedData;
          if (isPdf == "Y" && data.pdfPath) {
            window.open(data.pdfPath, "_blank");
          }
          if (isExcel == "Y" && data.excelPath) {
            window.open(data.excelPath, "_blank");
          }
        } else {
          this.courtseyRecords = [];
          this.groupedData = {};
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    updateLanguage(lang) {
      this.selectedLanguage = lang;
    },
  },
};
</script>
      
<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.rtl-table {
  direction: rtl;
  text-align: right;
}
.rtl-table-scroll {
  direction: rtl;
}
.text_right {
  text-align: right;
}
.reverse-order {
  direction: rtl;
}
.order {
  direction: ltr;
}
.user-header {
  padding: 5px;
  /* margin-left: 12px; */
  display: flex;
  font-weight: bold;
  justify-content: start;
  color: #3876d2;
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/FnbCourtseyRefundReport.vue